/* eslint-disable no-unused-vars */
import store from '../../store';
import { setBatchIndex } from '../../actions/myzone';
import { isEmpty } from 'Helpers/objects';

const QUEUE_LENGTH = 5;
const REQUEST_QUEUE_LENGTH = 2;
const DATA_LOAD_DELAY = 100;

const getCurrentBatch = () => {
    const state = store.getState() || {};
    const batchIndex = state && state.myZone && state.myZone.batchIndex;

    return batchIndex;
};

function getUserData(userId) {
    const state = store.getState() || {};
    const users = state && state.users;

    return users.elements ? users.elements[userId] : null;
}

function getItemData(itemId) {
    // Todo: GraphQL Logic
    const state = store.getState() || {};
    const adsData = state?.myZone?.adsData ?? null;

    return adsData ? adsData[itemId] : null;
}

export default class MyZoneDataLoader {
    static requestQueue = [];
    static requestServed = 0;
    static uniqueItemIds = {};
    static uniqueUserIds = {};
    static counter = 0;
    static batchedLength = 0;

    static loadThreadDataWithBatch(batchIndex, userId, itemId, fetchers, batchedLength) {
        if (batchIndex > getCurrentBatch()) {
            return;
        }
        this.loadThreadData(userId, itemId, fetchers, batchedLength);
    }

    static loadThreadData(userId, itemId, fetchers, batchedLength = 0) {
        this.batchedLength = batchedLength;
        if (this.batchedLength > 0) {
            this.counter += 1;
        }
        this.checkUserData(userId, fetchers.userFetch);
        this.checkItemData(itemId, fetchers.itemFetch);
    }

    static checkUserData(userId, userFetcher) {
        const userInfo = getUserData(userId);

        if (userId && !userInfo && !this.uniqueUserIds[userId]) {
            this.uniqueUserIds[userId] = true;
        }

        if ((this.counter === QUEUE_LENGTH && this.batchedLength !== 0) || (this.counter > 0 && this.counter === this.batchedLength)) {
            if (isEmpty(this.uniqueUserIds)) {
                this.increementRequestServed();
            }
            else {
                const userIdsInString = Object.keys(this.uniqueUserIds).toString();

                this.fetchUser(userIdsInString, userFetcher);
            }
        }
        else if (this.batchedLength === 0 && !userInfo && typeof userId !== 'undefined') {
            userFetcher({ userId });
        }
    }

    static fetchUser(userIds, userFetcher) {
        this.addToRequestQueue(userFetcher({ ids: userIds }));
    }

    static checkItemData(itemId, itemFetcher) {
        const itemInfo = getItemData(itemId);

        if (!itemInfo && !this.uniqueItemIds[itemId]) {
            this.uniqueItemIds[itemId] = true;
        }

        if ((this.counter === QUEUE_LENGTH && this.batchedLength !== 0) || (this.counter > 0 && this.counter === this.batchedLength)) {
            if (isEmpty(this.uniqueItemIds)) {
                this.increementRequestServed();
            }
            else {
                const itemIdsList = Object.keys(this.uniqueItemIds);

                this.fetchItem(itemIdsList, itemFetcher);
            }
        }
        else if (this.batchedLength === 0 && !itemInfo && typeof itemId !== 'undefined') {
            itemFetcher([itemId]);
        }
    }

    static fetchItem(itemIds, itemFetcher) {
        this.addToRequestQueue(itemFetcher(itemIds));
    }

    static increementRequestServed() {
        this.requestServed++;
        if (this.checkQueueLength()) {
            this.attachQueueCompleteEvent();
        }
    }

    static resetRequests() {
        this.requestQueue = [];
        this.requestServed = 0;
        this.uniqueItemIds = {};
        this.uniqueUserIds = {};
        this.counter = 0;
        this.messageIds = [];
    }

    static resetQueue() {
        if (this.requestServed === QUEUE_LENGTH) {
            this.resetRequests();
            setTimeout(() => {
                store.dispatch(setBatchIndex(getCurrentBatch() + 1));
            }, DATA_LOAD_DELAY);
        }
        else {
            this.resetRequests();
            store.dispatch(setBatchIndex(getCurrentBatch() + 1));
        }
    }

    static addToRequestQueue(req) {
        this.requestQueue.push(req);
        if (this.checkQueueLength()) {
            this.attachQueueCompleteEvent();
        }
    }

    static checkQueueLength() {
        return this.requestQueue.length === REQUEST_QUEUE_LENGTH - this.requestServed;
    }

    static attachQueueCompleteEvent() {
        Promise.all(this.requestQueue).then(() => {
            this.resetQueue();
        }).catch(() => {
            this.resetQueue();
        });
    }
}
